import { filter } from "rxjs";
//#region src/engine/rx-operators/notEmptyActions.ts
var notEmptyActions = filter((actions) => Boolean(actions.length));
//#endregion
export { notEmptyActions };
